import React, {useEffect, useState} from 'react'
import { TableWrapper } from '../../../libs/react-mpk/wrapper'
import Modal from '../../../libs/react-mpk/components/Modal'
import t from 'counterpart'
import service from './SandingAsetPerAset.service'
import moment from 'moment'
import { toast } from '../../../libs/react-mpk/services'
import Utils from '../../../libs/custom/Utils'
import { inject, observer } from 'mobx-react'

var _baseId = "mod-table-sanding-aset-peraset"

const SandingAsetPerAsetTable = ({
  className       = '',
  showCommandbar  = true,
  history,
  match,
  sipStore,
  navigationStore
}) => {

  const [confirmDelete, setConfirmDelete] = useState(false)
  const [confirmDeleteData, setConfirmDeleteData] = useState({})

  function _closeConfirmDelete() {
    setConfirmDelete(false)
  }
  async function _submitConfirmDelete(callback) {
    var r = await service.delete(confirmDeleteData.id)
    toast.info(`Data ${confirmDeleteData.nama} telah di hapus.`); callback()
    setConfirmDelete(false)
    TableWrapper.reload(_baseId)
  }

  return (
    <>
    <TableWrapper
      baseId={_baseId}
      title='Sanding Aset per Aset'
      className={className}
      // hintMessage={t.translate('modules.table.hint.message')}
      hintIconClassName="mdi mdi-information"
      hintMore={t.translate('modules.table.hint.more')}
      defaultData={[]}
      defaultSortBy="nama"
      columns={[
        {
          label: 'Tanggal Perolehan',
          searchable: true,
          key: 'tanggalPerolehan',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.tanggalPerolehan)
        },
        {
          label: 'Nomor Aktiva Tetap',
          searchable: true,
          key: 'nomor',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.nomor)
        },
        {
          label: 'Nama Aktiva Tetap',
          searchable: true,
          key: 'Nama',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.nama)
        },
        {
          label: 'Status Sanding',
          searchable: true,
          key: 'statusSanding',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.statusSanding)
        },
        {
          label: 'Masa Perolehan',
          searchable: true,
          key: 'masaPerolehan',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.masaPerolehan)
        },
        {
          label: 'Tahun Perolehan',
          searchable: true,
          key: 'tahunPerolehan',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.tahunPerolehan)
        },
        {
          label: 'Harga Perolehan',
          searchable: true,
          key: 'hargaPerolehan',
          type: TableWrapper.dataTypes.STRING,
          render: item => (Utils.numberFormat(item.hargaTotalPerolehan))
        }

      ]}
      actions={[
        // new TableWrapper.action('Add', 'mdi mdi-plus', () => history.push('/onpremise/penyusutan-periode-aset/baru'), true)
      ]}
      itemActions={[
        // new TableWrapper.action('Sanding per Aset', 'mdi mdi-book-open', (item) => {
        //   history.push(`/onpremise/sanding-aset-peraset/${item.id}`)
        // }, true),
        // new TableWrapper.action('Sanding per Akun', 'mdi mdi-book-open', (item) => {
        //   history.push(`/onpremise/sanding-aset-perakun/${item.id}`)
        // }, true),
      ]}
      onFetchData={ async query => {
        if(!query) query = {}
        // if(sipStore.periodeId) {
        //   query['periodeFiskalId.equals'] = sipStore.periodeId
        // }
        query['akunAktivaId.equals'] = match.params.id
        query['tanggalPerolehan.greaterThanOrEqual'] = sipStore.periode.dari
        query['tanggalPerolehan.lessThanOrEqual'] = sipStore.periode.ke
        return service.get(query)
      }}
      showCommandbar={showCommandbar}
      showFilterPeriod={false}
    />
    <Modal.Confirm
      // title="Hapus Data"
      visible={confirmDelete}
      onRequestClose={_closeConfirmDelete}
      onSubmit={_submitConfirmDelete}
    >Hapus data {confirmDeleteData.nama}?</Modal.Confirm>
    </>
  )
}

export default inject('sipStore', 'navigationStore')(observer(SandingAsetPerAsetTable))
